<template>
  <section
    v-if="valid"
    class="content-header"
    :class="{ '-imagebg': hasImage }"
  >
    <div
      v-if="hasImage"
      :class="imageSize === 0 ? '' : 'container-fluid-new px-0 header-image'"
    >
      <FocalImage
        :imageObject="imageObject"
        :overlay="gradientLayover"
        :overlayDirection="'top'"
      />
    </div>

    <div v-if="titleOnImage" class="content-header-title-layover">
      <div class="grid">
        <h1
          v-if="titleLevel === 'h1'"
          class="font-responsive-xl"
          :class="{
            'g-4 ': titlePlacement === 2,
            'g-5-6': titlePlacement === 3,
          }"
          v-html="title"
          :style="style"
        ></h1>
      </div>
    </div>

    <div class="content-header-content">
      <div class="grid header">
        <h1
          v-if="titleLevel === 'h1' && !titleOnImage"
          class="g-12"
          :class="[
            colStyleHalf ? 'g-md-6' : 'g-md-4',
            smallTitle ? 'font-responsive-larger' : 'font-responsive-xl',
          ]"
          v-html="title"
          :style="style"
        ></h1>
        <h2
          v-else-if="titleLevel === 'h2'"
          class="font-responsive-larger g-12"
          :class="colStyleHalf ? 'g-md-6' : 'g-md-4'"
          v-html="title.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')"
          :style="style"
        ></h2>

        <div
          v-if="titleLevel === 'h1'"
          class="lead-text font-responsive-body g-12 g-md-6"
          :class="titleOnImage ? 'g-md-5-6' : 'g-md-6'"
          :style="style"
        >
          <span v-html="lead" />
          <portal-target
            :multiple="false"
            name="lead-destination"
            class="lead-portal"
          />
        </div>
        <div
          v-else-if="titleLevel === 'h2'"
          class="lead-text font-responsive-body g-12"
          :class="colStyleHalf ? 'g-md-6' : 'g-md-8'"
          :style="style"
          v-html="lead"
        ></div>
      </div>
    </div>
  </section>
</template>
<script>
import FocalImage from '@/Scripts/components/media/Image/FocalImage.vue';
export default {
  name: 'ContentHeader',
  components: {
    FocalImage
  },
  props: {
    title: {
      type: String,
      required: true
    },
    titleLevel: {
      type: String,
      default: 'h2'
    },
    /**
     * 0 = content, 1 = text, 2 = content on image, 3 = text on image
     */
    titlePlacement: {
      type: Number,
      default: 0
    },
    colStyleHalf: {
      type: Boolean,
      default: true
    },
    lead: {
      type: String,
      default: ''
    },
    imageObject: Object,
    imageSize: {
      type: Number,
      default: 0
    },
    gradientLayover: {
      type: Boolean,
      default: false
    },
    fontColor: {
      type: String,
      default: ''
    },
    smallTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style () {
      return this.fontColor.length
        ? { color: `#${this.fontColor.replace('#', '')}` }
        : {};
    },
    hasImage () {
      return this.imageObject && this.imageObject.Url;
    },
    titleOnImage () {
      return (
        this.hasImage &&
        this.titlePlacement > 1 &&
        (this.$mqAliases.md || this.$mqAliases.desktop)
      );
    },

    valid () {
      if (
        typeof this.title !== 'undefined' &&
        this.title !== null &&
        this.title.length > 0
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" src="@/scss/components/components.content-header.scss"></style>
<style lang="scss" src="@/scss/components/components.overlay-image.scss"></style>
<style lang="scss" >
@import "@/scss/defaults.scss";

.content-header {
  .header-image {
    @include media-breakpoint-up(md) {
      padding-bottom: 16px;
    }
  }

  .content-header-title-layover .grid {
    padding-top: 0;
    padding-bottom: 0;
  }

  .grid.header {
    .grid-contentpage & {
      padding-top: 36px;
      padding-bottom: 36px;

      @include media-breakpoint-up(md) {
        padding-top: 52px;
        padding-bottom: 42px;
      }
    }

    h1 {
      margin-bottom: 8px;
    }
  }
}
</style>
